module.exports = __webpack_public_path__ + "img/jardin3.ccce0bc7.jpg";